var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "d-flex  align-items-start",
        { "text-justify": _vm.justify },
        { "single-line": _vm.singleLine },
        {
          "w-100 justify-content-between": _vm.spaceBetween,
        },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "ml-1 flex-shrink-0 d-flex align-items-center" },
        [
          _vm.icon
            ? _c("font-awesome-icon", {
                staticClass: "ml-2",
                class: _vm.iconClass,
                attrs: { icon: _vm.icon },
              })
            : _vm._e(),
          _c("span", { class: [_vm.masterClass, _vm.labelClass] }, [
            _vm._v(" " + _vm._s(_vm.label) + " : "),
          ]),
        ],
        1
      ),
      _c(
        "span",
        { class: [_vm.masterClass, _vm.valueClass] },
        [
          _vm.computedValue !== undefined
            ? [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.computedValue !== null ? _vm.computedValue : "-"
                    ) +
                    " "
                ),
              ]
            : _vm._e(),
          _vm._t("value"),
        ],
        2
      ),
      _vm.computedValue !== null && _vm.unit
        ? _c("span", { staticClass: "text-muted mr-1", class: _vm.unitClass }, [
            _vm._v(" " + _vm._s(_vm.unit) + " "),
          ])
        : _vm._e(),
      _vm._t("append"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }